<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('pollId')" class="col-sm-4 col-form-label">Poll ID</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('pollId')" v-model.lazy="pollId">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <div v-for="n in 10" :key="n">
        <div class="form-group form-row">
          <label :for="safeId('label' + (n - 1))" class="col-sm-4 col-form-label">Label {{ n }}</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" :id="safeId('label' + (n - 1))" v-model="labels[n - 1]"
                   @change="updateLabels()">
          </div>
        </div>
        <color-select-group :label="'Color ' + n" v-model="colors[n - 1]"
                            @change="updateColors()"></color-select-group>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapOverlayData } from '../../utils'
import * as action from '@/store/action-types'

export default {
  name: 'polling-results',
  mixins: [templateMixin],
  computed: {
    ...mapOverlayData(['pollId', 'title']),
    ...mapOverlayData({
      'labels': { type: Array, default: [] },
      'colors': { type: Array, default: [] }
    })
  },
  methods: {
    updateLabels () {
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: {
          labels: this.labels
        }
      })
    },
    updateColors () {
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: {
          colors: this.colors
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/polling-results.vue